import { render, staticRenderFns } from "./modal-with-vertical-icon.mpx?vue&type=template&id=d91243aa&isComponent&outputPath=components%2Fmodal-with-vertical-icon1addee8e%2Findex"
import script from "./modal-with-vertical-icon.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fmodal-with-vertical-icon1addee8e%2Findex"
export * from "./modal-with-vertical-icon.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fmodal-with-vertical-icon1addee8e%2Findex"
import style0 from "./modal-with-vertical-icon.mpx?vue&type=style&index=0&id=d91243aa&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_1addee8e%22%7D&isComponent&outputPath=components%2Fmodal-with-vertical-icon1addee8e%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports